// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"58cd6d96","511":"0c6da172","673":"0fb13be1","767":"f8789378"}[chunkId] + ".chunk.js";
};